import { StrictMode } from "react";
import { render } from "react-dom";
import { App } from "./components/App/App";
import { BrowserRouter } from "react-router-dom";
import { useLoggerStore } from "./logger/logger_store";
import { FluentProvider, webLightTheme } from "@fluentui/react-components";
import { LoadingPresentational } from "./components/Loading/LoadingPresentational";
import { updateItemStoreFromOffice, useItemStore } from "./mailitem/mail-item-store";
import { Severity } from "./components/Message/MessageContainer";
import { replaceConsoleLogging } from "./logger/remote_logger";

// replace console.xxx commands with ones that log remotely
replaceConsoleLogging();

// setup stores to update when office updates
Office.onReady(() => {
  if (Office.context.mailbox) {
    updateItemStoreFromOffice().catch((err) => console.error("Error updating item store from office: ", err)); // initial case
    // not present in modals
    Office.context.mailbox.addHandlerAsync(Office.EventType.ItemChanged, () => {
      // logger should be updated first so subsequent logs are correct
      useLoggerStore.getState().changeInteraction();
      updateItemStoreFromOffice().catch((err) => console.error("Error updating item store from office: ", err));
    });
  }
  useLoggerStore.getState().setInitialised();
  useItemStore.getState().setInitialised();
}).catch((err) => console.error("Error waiting office to become ready: ", err));

const Root = () => {
  const initialised = useItemStore((s) => s.initialised);

  return (
    <StrictMode>
      <FluentProvider
        style={{
          display: "flex",
          flexDirection: "column",
          flexGrow: "1",
          height: "100%",
        }}
        theme={webLightTheme}
      >
        {initialised ? (
          <BrowserRouter>
            <App />
          </BrowserRouter>
        ) : (
          <LoadingPresentational
            isLoading={true}
            severity={Severity.Information}
            title="Loading Smokeball for Outlook"
            message="Please wait while we connect Outlook to Smokeball..."
          />
        )}
      </FluentProvider>
    </StrictMode>
  );
};

render(<Root />, document.getElementById("container"));
